/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface AllevatoreDTO
 */
export interface AllevatoreDTO {
    /**
     * 
     * @type {number}
     * @memberof AllevatoreDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevatoreDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllevatoreDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof AllevatoreDTO
     */
    banca?: BancaDTO;
    /**
     * 
     * @type {number}
     * @memberof AllevatoreDTO
     */
    numeroAllevamenti?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AllevatoreDTO
     */
    superficieTotale?: number | null;
}

/**
 * Check if a given object implements the AllevatoreDTO interface.
 */
export function instanceOfAllevatoreDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AllevatoreDTOFromJSON(json: any): AllevatoreDTO {
    return AllevatoreDTOFromJSONTyped(json, false);
}

export function AllevatoreDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllevatoreDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
        'numeroAllevamenti': !exists(json, 'numeroAllevamenti') ? undefined : json['numeroAllevamenti'],
        'superficieTotale': !exists(json, 'superficieTotale') ? undefined : json['superficieTotale'],
    };
}

export function AllevatoreDTOToJSON(value?: AllevatoreDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
        'numeroAllevamenti': value.numeroAllevamenti,
        'superficieTotale': value.superficieTotale,
    };
}

